export default __webpack_public_path__ + "static/media/alexa5.b4d0fb39.webp";